module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-BoldItalic.3e7c0ae9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-BoldItalic.eot
// module id = 930
// module chunks = 0